<ng-container *ngIf="dataType" [ngSwitch]="dataType.name">
  <div *ngIf="type == ValueDataType.Text" class="filter-input">
    <input class="w-100p {{inputClass}}" type="text" [(ngModel)]="value" (ngModelChange)="onValueChange()" [disabled]="disabled" />
  </div>

  <div *ngIf="type == ValueDataType.Decimal" class="filter-input">
    <input class="w-100p {{inputClass}}" type="number" [(ngModel)]="value" (ngModelChange)="onValueChange()" [disabled]="disabled" />
  </div>

  <div *ngIf="type == ValueDataType.Number" class="filter-input">
    <input class="w-100p {{inputClass}}" type="number" [(ngModel)]="value" (ngModelChange)="onValueChange()" [disabled]="disabled" />
  </div>

  <div *ngIf="type == ValueDataType.Integer" class="filter-input">
    <input class="w-100p {{inputClass}}" type="number" [(ngModel)]="value" (ngModelChange)="onValueChange()" [disabled]="disabled" />
  </div>

  <div *ngIf="type == ValueDataType.Boolean" class="filter-input">
    <mat-select class="{{inputClass}}" panelClass="trg-outline-dropdown" [(ngModel)]="value" (ngModelChange)="onValueChange()" [disabled]="disabled">
      <mat-option [value]="true">True</mat-option>
      <mat-option [value]="false">False</mat-option>
    </mat-select>
  </div>

  <div *ngIf="type == ValueDataType.DateOnly" class="filter-input date-input" [appMomentFormats]="'date'">
    <input class="w-100p {{inputClass}} pointer" [matDatepicker]="picker" [(ngModel)]="date" (ngModelChange)="onDateChange()" (click)="picker.open()" [disabled]="disabled" readonly>
    <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="disabled">
      <i class="far fa-calendar-alt i-16 p-relative not-2 ol-5" matDatepickerToggleIcon></i>
    </mat-datepicker-toggle>
    <mat-datepicker #picker disabled="false" [disabled]="disabled"></mat-datepicker>
  </div>

  <ng-container *ngIf="type == ValueDataType.DateTime">
    <div class="filter-input date-time-input" fxLayout="row" [appMomentFormats]="'date'">
      <div class="date-part">
        <input class="w-100p {{inputClass}} pointer" [matDatepicker]="picker"
               [(ngModel)]="date" (ngModelChange)="onDateChange()" (click)="picker.open()" [disabled]="disabled" readonly>
        <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="disabled">
          <i class="far fa-calendar-alt i-16 p-relative not-2 ol-5" matDatepickerToggleIcon></i>
        </mat-datepicker-toggle>
        <mat-datepicker #picker disabled="false" [disabled]="disabled"></mat-datepicker>
      </div>
      <div class="time" *ngIf="showTimePicker">
        <div class="time-part time-part-hour">
          <div class="arrow-up" (click)="updateTime(1, 0, 0)" [class.disabled]="disabled">
            <i class="fas fa-chevron-up"></i>
          </div>
          <input class="w-100p {{inputClass}}"
                  type="text" [(ngModel)]="hourPart" (ngModelChange)="onTimeChange()" [disabled]="disabled" min="0" max="23" maxlength="2" />
          <div class="arrow-down" (click)="updateTime(-1, 0, 0)" [class.disabled]="disabled">
            <i class="fas fa-chevron-down"></i>
          </div>
        </div>
        <div class="time-part time-part-minute ml-2">
          <div class="arrow-up" (click)="canSetMinutes && updateTime(0, 1, 0)" [class.disabled]="disabled || !canSetMinutes">
            <i class="fas fa-chevron-up"></i>
          </div>
          <input class="w-100p {{inputClass}}"
                  type="text" [(ngModel)]="minutePart" (ngModelChange)="onTimeChange()" [disabled]="disabled || !canSetMinutes" min="0" max="59" maxlength="2" />
          <div class="arrow-up" (click)="canSetMinutes && updateTime(0, -1, 0)" [class.disabled]="disabled || !canSetMinutes">
            <i class="fas fa-chevron-down"></i>
          </div>
        </div>
        <div class="time-part time-part-second ml-2" *ngIf="showSeconds">
          <div class="arrow-up" (click)="canSetSeconds && updateTime(0, 0, 1)" [class.disabled]="disabled || !canSetSeconds">
            <i class="fas fa-chevron-up"></i>
          </div>
          <input class="w-100p {{inputClass}}"
                  type="text" [(ngModel)]="secondPart" (ngModelChange)="onTimeChange()" [disabled]="disabled || !canSetSeconds" min="0" max="59" maxlength="2" />
          <div class="arrow-up" (click)="canSetSeconds && updateTime(0, 0, -1)" [class.disabled]="disabled || !canSetSeconds">
            <i class="fas fa-chevron-down"></i>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="type == ValueDataType.TimeOnly">
    <div class="time">
      <div class="time-part time-part-hour">
        <div class="arrow-up" (click)="updateTime(1, 0, 0)" [class.disabled]="disabled">
          <i class="fas fa-chevron-up"></i>
        </div>
        <input class="w-100p {{inputClass}}"
               type="text" [(ngModel)]="hourPart" (ngModelChange)="onTimeChange()" [disabled]="disabled" min="0" max="23" maxlength="2" />
        <div class="arrow-down" (click)="updateTime(-1, 0, 0)" [class.disabled]="disabled">
          <i class="fas fa-chevron-down"></i>
        </div>
      </div>
      <div class="time-part time-part-minute ml-2">
        <div class="arrow-up" (click)="canSetMinutes && updateTime(0, 1, 0)" [class.disabled]="disabled || !canSetMinutes">
          <i class="fas fa-chevron-up"></i>
        </div>
        <input class="w-100p {{inputClass}}"
               type="text" [(ngModel)]="minutePart" (ngModelChange)="onTimeChange()" [disabled]="disabled || !canSetMinutes" min="0" max="59" maxlength="2" />
        <div class="arrow-up" (click)="canSetMinutes && updateTime(0, -1, 0)" [class.disabled]="disabled || !canSetMinutes">
          <i class="fas fa-chevron-down"></i>
        </div>
      </div>
      <div class="time-part time-part-second ml-2" *ngIf="showSeconds">
        <div class="arrow-up" (click)="canSetSeconds && updateTime(0, 0, 1)" [class.disabled]="disabled || !canSetSeconds">
          <i class="fas fa-chevron-up"></i>
        </div>
        <input class="w-100p {{inputClass}}"
               type="text" [(ngModel)]="secondPart" (ngModelChange)="onTimeChange()" [disabled]="disabled || !canSetSeconds" min="0" max="59" maxlength="2" />
        <div class="arrow-up" (click)="canSetSeconds && updateTime(0, 0, -1)" [class.disabled]="disabled || !canSetSeconds">
          <i class="fas fa-chevron-down"></i>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
